import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";
import { useScrollTop } from "../hook/useScrollTop";
import afroAcademyImg from "../images/afro-academy.jpg";
import image_1 from "../images/afro-academy/Picture4.png";
import afroJobLogo from "../images/afro-job-logo.png";
import BuildCareer from "../sections/afro-academy/build-career";
import AfroHeader from "../sections/afro-academy/header";
import JumpstartCareer from "../sections/afro-academy/jumpstart-career";
import ProfessionalCareer from "../sections/afro-academy/professional-career";
import Services from "../sections/afro-academy/services";
import TrainingCenter from "../sections/afro-academy/training-center";

const AfroAcademy = () => {
  useScrollTop();
  return (
    <>
      <Helmet>
        <title>AFRO || Afro Academy</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={afroAcademyImg}>
        <div className="pt-7 text-center">
          <div className="">
            <img src={image_1} className="img-fluid" loading="lazy" alt="" />
          </div>
          <div className="text-white mt-9">
            <h1 className="fs-28 lh-40 gilroy-bold pb-5">
              Professional Career Development Programs
            </h1>
            <h2 className="fs-56 lh-64 gilroy-bold">
              Building the Next Layer <br className="d-none d-md-block" /> &
              Strengthen the Company
            </h2>
          </div>
        </div>
      </Header>
      <Link
        to="/build-your-career"
        className="rakib d-block"
        // href="https://aemali.com"
        // target="_blank"
        // rel="noreferrer"
      >
        <div className="container d-flex justify-content-between align-items-center flex-column py-4 py-lg-3 flex-lg-row text-center text-lg-start">
          <div className="py-2">
            <img src={afroJobLogo} alt="" />
          </div>
          <div>
            {/* <p className="mt-4 fw-700 mb-0" style={{ fontSize: "20px" }}>
              Make Your Work Flow.
            </p> */}
            <p className="mb-1" style={{ fontSize: "18px" }}>
              Afro Internship Summer Program Open
            </p>
          </div>
          <div>
            <Link
              // href="https://aemali.com/customer/login"
              // target="_blank"
              // rel="noreferrer"
              to="/career"
              className="px-5 py-3 rounded inline-block fw-700"
              style={{
                fontSize: "16px",
                letterSpacing: "1.5px",
              }}
            >
              Apply Now
            </Link>
          </div>
        </div>
      </Link>
      <AfroHeader />
      {/* <Work /> */}
      <Services />
      <JumpstartCareer />
      <BuildCareer />
      <ProfessionalCareer />
      <TrainingCenter />
      <Footer />
    </>
  );
};

export default AfroAcademy;
